import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de asertividad
 */
class AsertividadRequest {
    /**
     * Llamada el endpoint de django para obtener el reporte
     * de asertividad
     * @param: values. Parámetros para el filtrado
     * @return: Un reporte de asertividad.
     */
    static ReporteAsertividad(values) {
        return middleware.hasAuth(() => request.get(`api/reporte-asertividad/`, {
            params: {
                fecha_inicial : values.fecha_inicial,
                fecha_final: values.fecha_final,
                drive_id: values.drive_id,
                categoria_id: values.categoria_id,
                busqueda_articulo: values.busqueda_articulo
            }
        }))
    }
}

export default AsertividadRequest;